import { useMemo } from 'react';
import { priceFormatter } from '../utils/formatters';

export default function ChartLegend({ categories, inline = false }) {
  const flatCategories = useMemo(() => {
    const catPrices = categories
      .filter(({ available }) => available)
      .reduce(
        (acc, value) => ({
          ...acc,
          [value.categories_id]: [...(acc[value.categories_id] || []), value.price - value.price * value.discount],
        }),
        {}
      );

    return Object.keys(catPrices).map((key) => {
      const { name, color } = categories.find(({ categories_id }) => categories_id === +key);
      const prices = catPrices[key];
      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);
      return {
        categoriesId: key,
        name,
        color,
        multiPrice: prices.length > 1 && minPrice !== maxPrice,
        minPrice,
        maxPrice,
      };
    });
  }, [categories]);

  const containerStyle = {
    backgroundColor: 'transparent',
    pointerEvents: inline ? 'auto' : 'none',
    zIndex: 500,
    cursor: 'default',
    textAlign: inline ? 'left' : 'center',
    marginTop: '10px',
    display: 'flex',
    position: 'relative',
    width: '100%',
    alignItems: 'flex-start',
    ...(inline
      ? {
          flexWrap: 'nowrap',
          overflowX: 'auto',
          overflowY: 'hidden',
          gap: '8px',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'thin',
          msOverflowStyle: '-ms-autohiding-scrollbar',
        }
      : {
          maxHeight: '140px',
          flexWrap: 'wrap',
          justifyContent: 'center',
          overflowY: 'auto',
        }),
  };

  const itemStyleBase = {
    color: '#b3b3b3',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '13px',
    fontWeight: 600,
    display: 'inline-flex',
    marginBottom: '10px',
    marginLeft: '4px',
    marginRight: '4px',
    ...(inline ? { flex: '0 0 auto' } : {}),
  };

  const dotStyle = (color) => ({
    marginRight: '6px',
    width: '12px',
    height: '12px',
    backgroundColor: color,
    borderRadius: '49%',
    flexShrink: 0,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',
    position: 'relative',
  });

  return (
    <div style={containerStyle}>
      {flatCategories.map(({ categoriesId, multiPrice, minPrice, maxPrice, name, color }) => (
        <div key={categoriesId} style={itemStyleBase}>
          <div style={dotStyle(color)} />
          <span>
            {`${name}: ${
              multiPrice ? `${priceFormatter(minPrice)} - ${priceFormatter(maxPrice)}` : `${priceFormatter(minPrice)}`
            }`}
          </span>
        </div>
      ))}
    </div>
  );
}
